import { fetchGetters } from '@/store/extensions/fetch';
import { createGetters } from '@/store/extensions/create';
import { updateGetters } from '@/store/extensions/update';
import { deleteGetters } from '@/store/extensions/delete';

export default {
  ...fetchGetters,
  ...createGetters,
  ...updateGetters,
  ...deleteGetters,

  context: state => state.context,
  formModalOpened: state => state.formModalOpened,
  ptoFromContext: (state, getters) => (
    state.context ? getters.find(state.context) : null
  ),
};



// WEBPACK FOOTER //
// ./src/store/modules/pto/getters.js